import React from 'react';
import companyNames from 'constants/companyNames';
import images from 'constants/images';
import propTypes from 'prop-types';
import useBrandLogo from 'hooks/useBrandLogo';
import { cn } from 'lib/utils';
import { getCompany } from 'helpers/getCompanyVariables';
import SunshineLoginBranding from './SunshineLoginBranding';

const isOneill = getCompany() === 'oneill';

// sunshine has no card: the form sits straight on the login artwork. the padding
// stays so the fields keep the width and position they had inside the old white box.
// fluid up to 400px with a 15px gutter each side, so no breakpoint is needed and
// the card no longer overflows phones narrower than 430px
const formContainerBase =
  'w-[calc(100%-30px)] max-w-[400px] min-h-[100px] h-max px-[45px] py-5';
const oneillFormContainer = `${formContainerBase} bg-white rounded-[15px]`;

/**
 * shell around every unauthenticated form: login, registration and password flows
 * @param children - the form rendered inside the card
 * @param width - optional max width for the card, replaces the 400px default
 */
export default function LoginFormContainer({ children, width = '' }) {
  // resolved here so the branding block stays presentational
  const { hasKnownBrand } = useBrandLogo('fullLogo');

  return (
    <div
      className={cn(
        'min-h-screen w-full flex items-center justify-center',
        !isOneill && 'flex-col'
      )}
    >
      {!isOneill && <SunshineLoginBranding hasKnownBrand={hasKnownBrand} />}
      {isOneill && (
        <div
          className={oneillFormContainer}
          style={width ? { maxWidth: width } : null}
        >
          <img
            src={images.brand.fullLogo}
            alt={companyNames.short + ' logo'}
            className='block w-full h-[55px] mb-5'
          />
          {children}
        </div>
      )}
      {!isOneill && (
        <div className='w-full flex flex-col items-center justify-center pt-[18px]'>
          <div
            className={formContainerBase}
            style={width ? { maxWidth: width } : null}
          >
            {children}
          </div>
        </div>
      )}
    </div>
  );
}

LoginFormContainer.propTypes = {
  children: propTypes.node,
  width: propTypes.string
};
